/* eslint-disable import/no-extraneous-dependencies */
import GaugeChart from 'react-advanced-gauge-chart';

import './styles.css';

type TProps = {
	id: string;
	percent: number;
	description: string;
};
const GaugeChartComponent = ({percent, description, id}: TProps) => (
	<>
		<GaugeChart
			id={id}
			arcsLength={[0.5, 0.3, 0.2]}
			arcPadding={0.01}
			arcWidth={0.15}
			nrOfLevels={15}
			colors={['#b3d48d', '#f4bc26', '#F3795B']}
			percent={percent}
			needleColor="#333"
			fontSize="8px"
			textColor="#333"
			className="gauge-chart-a display-4 grap"
			marginInPercent={0.02}
			cornerRadius={4}
		/>
		<p className="font-weight-bold text-center h6">{description}</p>
	</>
);

export default GaugeChartComponent;
